<template>
  <div class="statistic-widget-design-summary">
    <h5 class="mb-0 title">Creator Idea Summary {{ date }}</h5>
    <table v-if="Object.keys(data).length > 0" class="align-middle mb-0 table table-borderless table-striped table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th class="text-center">Created</th>
          <th class="text-center">Reviewed</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ item?.name || '-' }}</div>
                </div>
              </div>
            </div>
          </td>
          <td class="text-center">{{ item?.data?.['un-assigned'] || '-' }}</td>
          <td class="text-center">{{ item?.data?.['create-mockup'] || '-' }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else class="mt-2">No data available</div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config?.data?.data || []
    },
    date() {
      return this.config?.data?.date ? `(${this.config?.data?.date})` : ''
    }
  },
  methods: {},
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-design-summary {
  .chart {
    max-height: 350px;
  }
}
</style>
